import ConfigService from './ConfigService';

export const configService = new ConfigService();
